// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ScheduleItemFilterEmployeeResponse } from './schedule-item-filter-employee-response';

/** See com.rev360.pms.api.controller.shared.preferences.ScheduleFilterResponse */
/* istanbul ignore next */
@GandalfModel
export class ScheduleFilterResponse extends GandalfModelBase {

	@GandalfArray(ScheduleItemFilterEmployeeResponse)
	employees!: ScheduleItemFilterEmployeeResponse[];

	@GandalfConstantDecorator(constants.ScheduleItemType) 
	@GandalfArray(constants.ScheduleItemType)
	itemTypes!: constants.ScheduleItemType[];

	@GandalfArray(Number)
	roleIds!: number[];

	@GandalfArray(ScheduleItemFilterEmployeeResponse)
	sortEmployees!: ScheduleItemFilterEmployeeResponse[];

	@GandalfConstantDecorator(constants.ScheduleItemFilterStatus) 
	@GandalfArray(constants.ScheduleItemFilterStatus)
	statuses!: constants.ScheduleItemFilterStatus[];

}
